/** 与后端 UserPermissionCodes.java 对齐 */
export const USER_PERMISSION = {
  comicProjectRead: "comic:project:read",
  comicProjectCreate: "comic:project:create",
  comicProjectUpdate: "comic:project:update",
  comicProjectDelete: "comic:project:delete",
  comicPageImagePersist: "comic:page-image:persist",
  comicEpisodeJobCreate: "comic:episode-job:create",
  comicEpisodeJobRead: "comic:episode-job:read",
  comicEpisodeJobCancel: "comic:episode-job:cancel",
  comicEpisodeJobResume: "comic:episode-job:resume",
  creationTaskSubmit: "creation:task:submit",
  creationTaskRead: "creation:task:read",
  workflowRunCreate: "workflow:run:create",
  workflowRunRead: "workflow:run:read",
  workflowRunCancel: "workflow:run:cancel",
  workflowDefinitionRead: "workflow:definition:read",
  workflowDefinitionWrite: "workflow:definition:write",
  agentRunCreate: "agent:run:create",
  agentRunRead: "agent:run:read",
  agentRunConfirm: "agent:run:confirm",
  storageGalleryOwn: "storage:gallery:own"
} as const;

export type UserPermissionCode =
  (typeof USER_PERMISSION)[keyof typeof USER_PERMISSION];

/** 路由前缀 → read 权限；undefined 表示登录即可 */
export const USER_ROUTE_READ_PERMISSION: Record<string, UserPermissionCode | undefined> = {
  "/create": USER_PERMISSION.creationTaskRead,
  "/workflows": USER_PERMISSION.workflowDefinitionRead,
  "/agents": USER_PERMISSION.agentRunRead,
  "/library": USER_PERMISSION.creationTaskRead,
  "/comics": USER_PERMISSION.comicProjectRead
};

export function resolveUserRouteReadPermission(pathname: string): UserPermissionCode | undefined {
  const normalized = pathname.replace(/\/+$/, "") || "/";
  if (USER_ROUTE_READ_PERMISSION[normalized] !== undefined) {
    return USER_ROUTE_READ_PERMISSION[normalized];
  }
  if (normalized.startsWith("/comics/")) {
    return USER_PERMISSION.comicProjectRead;
  }
  if (normalized.startsWith("/workflows/")) {
    return USER_PERMISSION.workflowDefinitionRead;
  }
  if (normalized.startsWith("/agents/")) {
    return USER_PERMISSION.agentRunRead;
  }
  return undefined;
}

export function hasUserPermission(
  permissions: readonly string[] | undefined,
  code: string | undefined
): boolean {
  if (!code) return true;
  if (!permissions?.length) return false;
  return permissions.includes(code);
}
